import "./LodhaLandingPage.css";
import { useEffect, useState } from "react";
import { Modal } from "antd";
import LodhaLogo from "../../assest/img/lodha-page/lodha-group-logo.png";
import Banner from "../../assest/img/lodha-page/banner.webp";
import MahalaxmiLogo from "../../assest/img/lodha-page/mahalaxmi-logo.png";
import HeadingDivider from "../../assest/img/lodha-page/divider.png";
import LeftBanner from "../../assest/img/lodha-page/2.webp";
import Gall1 from "../../assest/img/lodha-page/3.webp";
import Gall2 from "../../assest/img/lodha-page/4.webp";
import Gall3 from "../../assest/img/lodha-page/8.webp";
import Gall4 from "../../assest/img/lodha-page/6.webp";
import Gall5 from "../../assest/img/lodha-page/7.webp";
import RegisterImg from "../../assest/img/lodha-page/register-now.png";
import IconOne from "../../assest/img/lodha-page/icons/1.png";
import IconTwo from "../../assest/img/lodha-page/icons/2.png";
import IconThree from "../../assest/img/lodha-page/icons/3.png";
import IconFour from "../../assest/img/lodha-page/icons/4.png";
import { LuIndianRupee } from "react-icons/lu";
import { Helmet } from "react-helmet";
import LodhaRegistration from "../LodhaRegistration/LodhaRegistration";


export default function LodhaLandingPage() {
  const [modal1Open, setModal1Open] = useState(false);
  useEffect(() => {
    // Check if the tag has already been inserted by using a flag on the window object
    if (!window.gtmNoscriptInserted) {
      const noscriptTag = document.createElement('noscript');
      noscriptTag.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WN247J9T"
          height="0" width="0" style="display:none;visibility:hidden">
        </iframe>
      `;

      // Insert the noscript tag inside the body, right after the body tag starts
      const body = document.body;
      const firstChild = body.firstChild;
      body.insertBefore(noscriptTag, firstChild);

      // Mark the tag as inserted
      window.gtmNoscriptInserted = true;
    }
  }, []);
  return (
    <>
      <Helmet>

        {/* Google Site Verification */}
        <meta name="google-site-verification" content="d1pDlQqXNiqKPUUP_Cv1IgBCRRWEBAcDiH80bOgMFsc" />

        {/* Google Analytics (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-V229CW91V4"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-V229CW91V4');
      `}
        </script>

        {/* Google Tag Manager */}
        <script>
          {`
        (function(w,d,s,l,i){
          w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-WN247J9T');
      `}
        </script>
        {/* <!-- Meta Pixel Code --> */}
        <script>{
          `!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '24422068880798200');
          fbq('track', 'PageView');`}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=24422068880798200&ev=PageView&noscript=1"
        />`}
        </noscript>


        <title>Lodha Group - Imperial Living</title>
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:title"
          content="Lodha Group - Imperial Living"
        />
        <meta
          property="og:description"
          content="Book your 2 or 3 BHK apartment with Lodha Group - Imperial Living, Jogeshwari Mumbai. These homes offer modern amenities, spacious layouts, 70% Open Greens With Age-old Trees-nature, Preserved For Generations. Whether you need a cozy 2 BHK or a larger 3 BHK, find the perfect home for your family today!"
        />
        <meta
          property="og:url"
          content=""
        />
        <meta
          property="og:image"
          content=""
        />

        <link
          rel="canonical"
          href=""
        />


      </Helmet>
      <div className="landing-page-dubai">
        <section className="banner">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="top-logo">
                  <img
                    src={LodhaLogo}
                    className="img-fluid"
                    alt="Lodha Group Logo"
                  />
                  {/* <img
                    src={RunwalLogo}
                    className="img-fluid"
                    alt="Runwal Logo"
                  /> */}
                </div>
              </div>
              <div className="col-12 text-center mt-lg-5 pt-lg-5">
                {/* <img
                  src={MahalaxmiLogo}
                  className="img-fluid mid-logo"
                  alt="Mahalaxmi Logo"
                /> */}
                <h1>JOGESHWARI MUMBAI</h1>
                <h2>IMPERIAL LIVING</h2>
                {/* <img
                  src={Arrow}
                  className="img-fluid explore-icon"
                  alt="Explore"
                /> */}
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="banner-img">
                  <img src={Banner} alt="banner" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="overview-section py-4 py-lg-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-10 mx-auto">
                <div className="heading">
                  <h2>An Address Fit For Royalty.</h2>
                  <img src={HeadingDivider} className="img-fluid" alt="" />
                </div>
                <div className="row two-headings-section">
                  <img src={HeadingDivider} className="img-fluid" alt="" />
                  <div className="col-lg-6 heading">
                    <h3>
                      Time bows to nature.
                    </h3>
                    <p>70% Open Greens With Age-old Trees-nature, Preserved For Generations.</p>
                  </div>
                  <div className="col-lg-6 heading">
                    <h3>
                      Celebrations deserve a stage.
                    </h3>
                    <p>
                      A Grand Clubhouse For Gatherings. Play, And Moments That Dazzle.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section className="overview-section event-detail-section py-4 bg-white mb-5">
          <div className="container">
            <div className="row ">
              <div className="col-12 text-center">
                <h2>
                  You're Invited to Visit us for One-to-One Meeting
                </h2>
              </div>
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="event-detail">
                  <div className="content">
                    <h2>
                      UNVEILING SOON
                    </h2>
                    <div className="left-section">
                      17 & 18, <br /> <span>October 2025.</span>
                    </div>
                    <div className="right-section">
                      <h4>Holiday Inn Doha - The Business Park</h4>
                      <p className="date">
                        Business Park, Airport Road, Doha, Qatar.
                      </p>
                      <p className="date">
                        Time: on 17 - 3pm to 7pm on 18 - 11am to 7pm
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <LodhaRegistration />
              </div>
            </div>
          </div>
        </section>
        <section className="overview-section pb-5">
          <div className="container-fluid px-lg-4">
            <div className="row ">
              <div className="col-lg-5">
                <img
                  src={LeftBanner}
                  className="img-fluid left-banner"
                  alt="Banner"
                />
              </div>
              <div className="col-lg-7 content">
                {/* <div>
                <h2 className="mb-2">CITY SEASONS TOWERS DUBAI</h2>
                <h6 className="mb-2">
                  Sheikh Khalifa Bin Zayed Rd,
                  <br /> Next to Burjuman Mall،
                  <br /> Mankhool - Dubai - United Arab Emirates.
                </h6>
                <h3>26 & 27, October 2025.</h3>
                <h3>Sat - Sun from 11:00 am to 07:00 pm</h3>
              </div> */}
                <div>
                  <h4 className="mb-2">Address fit for Royalty </h4>
                  <p className="mb-4 content-text">
                    Book your 2 or 3 BHK apartment with Lodha Group - Imperial Living, Jogeshwari Mumbai.
                    These homes offer modern amenities, spacious layouts, 70% Open Greens With Age-old Trees-nature, Preserved For Generations. Whether you need a cozy 2 BHK or
                    a larger 3 BHK, find the perfect home for your family today!
                  </p>
                </div>
                <div className="head">
                  <p className="ps-lg-0">Configuration</p>
                  <p>
                    Carpet Areas
                  </p>
                  <p>
                    Anchor Pricing (<LuIndianRupee />)
                  </p>
                </div>
                <div className="head-content">
                  <div>
                    <p className="pt-0">2 Bed + Study</p>
                    <p>3 Bed</p>

                    <div>
                      <p>3 Bed + Study</p>
                    </div>
                  </div>
                  <div>
                    <p className="pt-0">950 - 1050 sq. ft.</p>
                    <p>1150 - 1250 sq. ft.</p>
                    <p>1350 - 1450 sq. ft.</p>
                  </div>
                  <div>
                    <p className="pt-0">3.60 Cr++</p>
                    <p>4.41 Cr++</p>
                    <p>5.22 Cr++</p>
                  </div>
                </div>

                {/* <button type="button" onClick={() => setModal1Open(true)}>
                  Register Now
                </button> */}
              </div>
              <div className="col-12">
                <div className="gallery-section">
                  <img src={Gall1} alt="" className="img-fluid" />
                  <img src={Gall2} alt="" className="img-fluid" />
                  <img src={Gall3} alt="" className="img-fluid" />
                  <img src={Gall4} alt="" className="img-fluid" />
                  <img src={Gall5} alt="" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="overview-section four-cards-section pt-4">
          <div className="container">
            <div className="row ">
              <div className="col-12 content">
                <div className="text-white heading">
                  <h2 className="text-white">
                    Celebrations deserve a stage.
                  </h2>
                  <p>
                    A Grand Clubhouse For Gatherings. Play, And Moments That Dazzle.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <img src={LodhaLogo} alt="" className="img-fluid" />
              </div>
            </div>
          </div>
        </footer>
        <Modal
          width={1000}
          centered
          open={modal1Open}
          onOk={() => setModal1Open(false)}
          onCancel={() => setModal1Open(false)}
          footer={false}>
          <div className="row landing-page-modal">
            <div className="col-lg-6 mb-3 mb-lg-0">
              <img src={RegisterImg} className="img-fluid" alt="Banner" />
            </div>
            <div className="col-lg-6">
              <LodhaRegistration />
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
}
